import { IEmployeeFilter } from 'modules/users/employees/store/models';
import { combineReducers } from 'redux';
import { IUserInfo } from 'shared/models/User';
import { defaultInfinityScrollState, IInfinityScrollState } from 'store/reducerUtils';
import {
    EmployeesActions, getMoreEmployeesAction, initialLoadEmployees, refreshEmployees, setEmployeesFilter,
} from 'modules/users/employees/store/actions';

export function employeesTable(
    state: IInfinityScrollState<IUserInfo>,
    action: EmployeesActions,
): IInfinityScrollState<IUserInfo> {
    state = state || defaultInfinityScrollState;
    switch (action.type) {
        case setEmployeesFilter.action:
        case initialLoadEmployees.action:
        case refreshEmployees.action:
            return {
                ...defaultInfinityScrollState,
                isLoading: true,
            };
        case getMoreEmployeesAction.errorType:
            return {
                ...state,
                isLoading: false,
            };
        case getMoreEmployeesAction.successType:
            return {
                // @ts-ignore
                total: action.payload.total_users,
                // @ts-ignore
                items: [...state.items, ...action.payload.users.map(user => user.id)],
                isLoading: false,
            };
        default:
            return state;
    }
}

function employeesFilter(
    state: IEmployeeFilter,
    action: EmployeesActions,
): IEmployeeFilter {
    const defaultState = {};
    state = state || defaultState;
    switch (action.type) {
        case initialLoadEmployees.action:
            return defaultState;
        case setEmployeesFilter.action:
            // @ts-ignore
            return action.payload;
        default:
            return state;
    }
}

export const employees = combineReducers({
    employeesTable,
    employeesFilter,
});
